import { render, staticRenderFns } from "./NotificationUpdateMetadataDialog.vue?vue&type=template&id=a59b5220&scoped=true&"
import script from "./NotificationUpdateMetadataDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationUpdateMetadataDialog.vue?vue&type=script&lang=js&"
import style0 from "./NotificationUpdateMetadataDialog.vue?vue&type=style&index=0&id=a59b5220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59b5220",
  null
  
)

export default component.exports